import { useQuery } from '@tanstack/react-query';
import { getPropertyStatisticsRequest, IPropertyStatisticsResponse } from '@/api/statistics';

function usePropertyStatistics(propertyId: number) {
  const {
    data,
    isLoading,
    isError,
    error,
    isSuccess,
    isFetching,
    refetch,
  } = useQuery<IPropertyStatisticsResponse, Error>({
    queryKey: ['propertyStatistics', propertyId],
    queryFn: () => getPropertyStatisticsRequest(propertyId),
    enabled: !!propertyId, // Запит буде виконано, тільки якщо propertyId існує
  });

  return {
    statistics: data?.data, // Повертаємо тільки дані статистики
    isLoading,
    isError,
    error,
    isSuccess,
    isFetching,
    refetch,
  };
}

export default usePropertyStatistics;
